var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Arrow---Down-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Down-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M0.283445 0.258435C0.627015 -0.0548196 1.16465 -0.0832973 1.5435 0.173002L1.65204 0.258435L10 7.86941L18.348 0.258435C18.6915 -0.0548196 19.2292 -0.0832973 19.608 0.173002L19.7166 0.258435C20.0601 0.57169 20.0914 1.06188 19.8103 1.40731L19.7166 1.50627L10.6843 9.74156C10.3407 10.0548 9.8031 10.0833 9.42424 9.827L9.3157 9.74156L0.283445 1.50627C-0.0944817 1.16169 -0.0944817 0.603015 0.283445 0.258435Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Down-2_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1_2",
    d: "M0.283445 0.258435C0.627015 -0.0548196 1.16465 -0.0832973 1.5435 0.173002L1.65204 0.258435L10 7.86941L18.348 0.258435C18.6915 -0.0548196 19.2292 -0.0832973 19.608 0.173002L19.7166 0.258435C20.0601 0.57169 20.0914 1.06188 19.8103 1.40731L19.7166 1.50627L10.6843 9.74156C10.3407 10.0548 9.8031 10.0833 9.42424 9.827L9.3157 9.74156L0.283445 1.50627C-0.0944817 1.16169 -0.0944817 0.603015 0.283445 0.258435Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.283c512c4a83b0bee37100e4d12780df.svg";
export { ForwardRef as ReactComponent };